const translation: Record<string, string> = {
  "nav.home": "Strona Główna",
  "nav.categories": "Kategorie",
  "nav.article": "Poradnik",
  "hero.title1": "Kakobuy Spreadsheet",
  "hero.title2": "Polska Baza Produktów 2026",
  "hero.description1": "Największa niezależna baza produktów z Chin.",
  "hero.description2": "Codziennie aktualizowane Kakobuy Finds.",
  "hero.cta_primary": "Kakobuy Sheet",
  "hero.cta_secondary": "Buy It Now",
  "trust.label": "DLACZEGO WARTO ZAUFAĆ NASZEJ BAZIE?",
  "trust.text1": "Kakobuy Sheet to największy w Polsce, niezależny arkusz produktowy łączący ponad 1000 zweryfikowanych produktów z chińskich platform zakupowych. Nasza baza Kakobuy Finds jest codziennie aktualizowana, aby zapewnić Ci dostęp do najświeższych okazji, sprawdzonych sprzedawców i dokładnych opisów produktów. Niezależnie od tego, czy szukasz sneakersów, modnych ubrań, elektroniki czy akcesoriów — nasz Kakobuy Spreadsheet to Twoje kompleksowe narzędzie do bezpiecznych i świadomych zakupów. Dołącz do tysięcy zadowolonych użytkowników, którzy codziennie korzystają z naszej bazy, by oszczędzać czas i pieniądze.",
  "featured.title": "Odkryj Nasze Kategorie",
  "featured.subtitle": "14 kategorii produktowych z codziennymi aktualizacjami. Znajdź najlepsze okazje w jednym miejscu.",
  "featured.shoes": "Buty",
  "featured.hoodies": "Bluzy",
  "featured.tshirts": "Koszulki",
  "featured.browse": "Przeglądaj",
  "featured.top": "TOP",
  "featured.new": "NOWOŚĆ",
  "grid.label": "15 SEKCJI PRODUKTÓW I PORADNIKÓW",
  "grid.title1": "Wszystko czego potrzebujesz",
  "grid.title2": "w jednym miejscu",
  "grid.subtitle": "Wybierz kategorię i przejdź do pełnej bazy produktów.",
  "grid.go": "Przejdź",
  "grid.read": "Przeczytaj",
  "grid.article_title": "Co to jest Kakobuy Sheet?",
  "grid.article_desc": "Kompletny przewodnik po arkuszu Kakobuy — dowiedz się jak działa i jak z niego korzystać.",
  "testimonials.label": "OPINIE UŻYTKOWNIKÓW",
  "testimonials.title1": "Zobacz co mówią",
  "testimonials.title2": "nasi użytkownicy",
  "testimonials.subtitle": "Niezależne opinie o korzystaniu z Kakobuy Spreadsheet.",
  "cta.line1": "Nie trać czasu na",
  "cta.line2": "przeglądanie setek stron",
  "cta.line3": "Kup teraz przez Kakobuy Sheet.",
  "cta.button": "Odwiedź kaspreadsheet.com",
  "footer.desc": "Największa polska baza Kakobuy Spreadsheet — niezależne porównania, przewodniki zakupowe i codziennie aktualizowane listy produktów.",
  "footer.categories_title": "KATEGORIE",
  "footer.seo_title": "SEO & PRZEWODNIKI",
  "footer.info_title": "INFORMACJE",
  "footer.about": "O nas",
  "footer.contact": "Kontakt",
  "footer.privacy": "Polityka prywatności",
  "footer.disclaimer": "Disclaimer",
  "footer.terms": "Regulamin",
  "footer.cookies": "Cookies",
  "footer.copyright": "© 2026 Kakobuy Finds. Wszelkie prawa zastrzeżone.",
  "article.back": "← Powrót do strony głównej",
  "article.read_more": "Czytaj więcej",
  "article.related": "Powiązane artykuły",
  "category.shoes": "Buty",
  "category.hoodies": "Bluzy/Swetry",
  "category.tshirts": "Koszulki",
  "category.jackets": "Kurtki",
  "category.pants": "Spodnie/Szorty",
  "category.headwear": "Nakrycia głowy",
  "category.sets": "Zestawy",
  "category.underwear": "Bielizna",
  "category.jersey": "Koszulki sportowe",
  "category.accessories": "Akcesoria",
  "category.bags": "Torby",
  "category.belts": "Paski",
  "category.perfumes": "Perfumy",
  "category.other": "Inne",
};

export default translation;